import { Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface OsDropOverlayProps {
  /** Whether to show the overlay (user is dragging an OS file over the explorer). */
  isVisible: boolean;
}

/**
 * Full-area overlay shown when the user drags a file from the OS onto the
 * document explorer. Provides visual confirmation that the area is a drop zone.
 */
export function OsDropOverlay({ isVisible }: OsDropOverlayProps) {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-lg border-2 border-dashed border-primary bg-primary/10">
      <div className="flex flex-col items-center gap-3 text-primary">
        <Upload className="size-10" aria-hidden="true" />
        <span className="text-base font-medium">{t('documents.dnd.dropToCreate')}</span>
      </div>
    </div>
  );
}
